import { trackingPageOrderSchema } from "@redotech/redo-model/order-tracking/tracking-page-order-definition";
import * as z from "zod";
import { SingleOrderAuthStatus } from "./single-order-auth";

export const getTrackingPageOrderWithCredentials = {
  name: "getTrackingPageOrderWithCredentials" as const,
  input: z.union([
    z.object({
      credentials: z.object({
        emailOrZip: z.string(),
        orderIdTrackingNumber: z.string(),
      }),
    }),
    z.object({ token: z.string() }),
  ]),
  output: z.union([
    z.object({
      trackingPageOrder: trackingPageOrderSchema.nullable(),
      jsMapsApiEnabled: z.boolean(),
    }),
    z.object({
      status: z.literal(SingleOrderAuthStatus.ORDER_SELECTION_REQUIRED),
      orders: z.array(
        z.object({ shopifyId: z.string(), orderName: z.string() }),
      ),
    }),
  ]),
};

export type GetTrackingPageOrderWithCredentialsOutput = z.infer<
  (typeof getTrackingPageOrderWithCredentials)["output"]
>;

export type OrderSelectionRequiredResponse = Extract<
  GetTrackingPageOrderWithCredentialsOutput,
  { status: typeof SingleOrderAuthStatus.ORDER_SELECTION_REQUIRED }
>;

/**
 * Type guard for the `ORDER_SELECTION_REQUIRED` arm. Callers must check this and
 * render the disambiguation UI before reading the order.
 */
export function isOrderSelectionRequired(
  response: GetTrackingPageOrderWithCredentialsOutput | undefined,
): response is OrderSelectionRequiredResponse {
  return (
    !!response &&
    "status" in response &&
    response.status === SingleOrderAuthStatus.ORDER_SELECTION_REQUIRED
  );
}
